import { RadioGroup, RadioGroupProps } from '@radix-ui/react-radio-group'

export type GroupProps = RadioGroupProps

export const Group = RadioGroup

export default Group
